import React from "react";
import { AvacusLogo } from "@/assets/img";

/** Shared loading UI that can render before the wallet SDK is loaded. */
export function AppLoadingScreen(): React.ReactElement {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-8 bg-background min-h-dvh">
      <div className="flex flex-col items-center gap-6">
        <img
          src={AvacusLogo}
          alt=""
          className="h-10 w-auto opacity-90"
          aria-hidden
        />
        <div className="h-0.5 w-28 overflow-hidden rounded-full bg-border">
          <div
            className="h-full w-10 shrink-0 rounded-full bg-primary"
            style={{ animation: "shimmer 1.4s ease-in-out infinite" }}
          />
        </div>
      </div>
    </div>
  );
}
